import { resize } from 'engine/resizeImage';
import { Camera, Images, X } from 'lucide-react';
import { useState, useRef } from 'react';
import type { UseFormSetValue } from 'react-hook-form';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function AvatarUpload({
	setValue,
	defaultValue,
}: {
	setValue: UseFormSetValue<{
		teamName: string;
		avatar?: File;
	}>;
	defaultValue?: string;
}) {
	const [preview, setPreview] = useState<string | null>(defaultValue || null);

	const inputRef = useRef<HTMLInputElement>(null);
	const [isUploading, setIsUploading] = useState(false);
	const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];
		setIsUploading(true);
		if (file) {
			console.log(file.size);
			setPreview(URL.createObjectURL(file));

			const resizedImage = await resize(file, {
				width: 2048,
				height: 2048,
			});
			setPreview(URL.createObjectURL(resizedImage));
			setIsUploading(false);
			setValue('avatar', resizedImage);
		}
	};

	const clearAvatar = () => {
		setPreview(null);
		if (inputRef.current) inputRef.current.value = '';
	};

	return (
		<div className="flex flex-col items-center gap-2">
			<div className="relative">
				<input
					id="avatar-upload"
					type="file"
					accept="image/*"
					name="avatar"
					ref={inputRef}
					onChange={handleFileChange}
					className="absolute inset-0 size-full cursor-pointer opacity-0"
					disabled={isUploading}
				/>

				<div
					className={`relative aspect-square w-full cursor-pointer overflow-hidden rounded-lg border-2 border-dashed p-3 skin-border-input hover:opacity-95`}
				>
					{preview ? (
						<>
							<img src={preview} alt="Preview" className="size-full object-cover" />

							<button
								type="button"
								onClick={clearAvatar}
								className="absolute right-2 top-2 rounded-full border border-gray-200 bg-white/80 p-1 shadow-sm shadow-black/30 hover:bg-white"
							>
								<X className="size-5 text-gray-950" />
							</button>
						</>
					) : (
						<div className="flex size-full columns-2 flex-row items-center justify-evenly gap-2 gap-x-8">
							<div
								className="flex flex-col items-center"
								onClick={() => {
									console.log(inputRef);
									inputRef.current?.setAttribute('capture', 'environment');
									inputRef.current?.click();
								}}
							>
								<Camera className="size-10 opacity-90 skin-text" />
								<span className="text-sm opacity-80 skin-text">{__`Take a photo`}</span>
							</div>
							<div
								className="flex flex-col items-center"
								onClick={() => {
									inputRef.current?.removeAttribute('capture');
									inputRef.current?.click();
								}}
							>
								<Images className="size-10 opacity-90 skin-text" />
								<span className="text-sm opacity-80 skin-text">{__`Upload an image`}</span>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
